// extracted by mini-css-extract-plugin
export default {"l_badge_main":"badge_l_badge_main__KCQCL","l_bage_mark_container":"badge_l_bage_mark_container__+N50U","l_bage_children_container":"badge_l_bage_children_container__W5VsP"};